import './App.css';
import RegistrationForm from './components/RegisterationForm';

function App() {
  return (
    <main className="page-container">
      <RegistrationForm />
    </main>
  );
}

export default App;
